export var NavigationModes;
(function (NavigationModes) {
    NavigationModes["CENTER"] = "Center";
    NavigationModes["END"] = "End";
    NavigationModes["START"] = "Start";
})(NavigationModes || (NavigationModes = {}));
//# sourceMappingURL=navigationModes.js.map